var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
export const BaseInput = forwardRef((_a, ref) => {
    var { className = '', hasError } = _a, props = __rest(_a, ["className", "hasError"]);
    return (_jsx("input", Object.assign({ ref: ref, className: `focus:!border-2 disabled:!cursor-not-allowed disabled:!opacity-50 !shadow-none
        ${hasError ? '!border-vjwDanger focus:!border-vjwDanger' : '!border-gray-300 focus:!border-vjwPrimary'} 
        ${className}` }, props)));
});
BaseInput.displayName = 'BaseInput';
